/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ReservationTypeFromJSON, ReservationTypeToJSON, } from './';
export function CalendarDtoFromJSON(json) {
    return CalendarDtoFromJSONTyped(json, false);
}
export function CalendarDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'reservationId': !exists(json, 'reservationId') ? undefined : json['reservationId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'type': !exists(json, 'type') ? undefined : ReservationTypeFromJSON(json['type']),
        'start': !exists(json, 'start') ? undefined : (new Date(json['start'])),
        'end': !exists(json, 'end') ? undefined : (new Date(json['end'])),
        'progress': !exists(json, 'progress') ? undefined : json['progress'],
        'calendarColorRGB': !exists(json, 'calendarColorRGB') ? undefined : json['calendarColorRGB'],
    };
}
export function CalendarDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'reservationId': value.reservationId,
        'name': value.name,
        'carId': value.carId,
        'type': ReservationTypeToJSON(value.type),
        'start': value.start === undefined ? undefined : (value.start.toISOString()),
        'end': value.end === undefined ? undefined : (value.end.toISOString()),
        'progress': value.progress,
        'calendarColorRGB': value.calendarColorRGB,
    };
}
